/**
 * Convert an object with CSS styles into a CSS string.
 *
 * @example
 * stylesToCSS({ color: 'red', 'font-weight': 'bold' }) // => "color:red;font-weight:bold;"
 */
export function stylesToCSS(styles?: Record<string, string>): string {
  return (
    styles &&
    Object.keys(styles).reduce((acc, key) => `${acc}${key}:${styles[key]};`, '')
  )
}

/**
 * Convert a CSS string into an object.
 */
export function cssToStyles(css?: string): Record<string, string> {
  if (!css) return {}
  return css.split(';').reduce((acc, def) => {
    const [key, value] = def.split(':')
    if (!key || !value) return acc
    else return { ...acc, [key.trim()]: value.trim() }
  }, {})
}
